/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramSupportContactsControllerGetSubjectsQueryResponse,
  TelegramSupportContactsControllerGetSubjects401,
} from '../../types/TelegramSupportContactsControllerGetSubjects.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { telegramSupportContactsGetSubjects } from '../../methods/telegramSupportContactsGetSubjects.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const telegramSupportContactsGetSubjectsQueryKey = () =>
  [{ url: '/api/telegram/support-contacts/subjects' }] as const;

export type TelegramSupportContactsGetSubjectsQueryKey = ReturnType<typeof telegramSupportContactsGetSubjectsQueryKey>;

export function telegramSupportContactsGetSubjectsQueryOptions(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = telegramSupportContactsGetSubjectsQueryKey();
  return queryOptions<
    TelegramSupportContactsControllerGetSubjectsQueryResponse,
    ResponseErrorConfig<TelegramSupportContactsControllerGetSubjects401>,
    TelegramSupportContactsControllerGetSubjectsQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return telegramSupportContactsGetSubjects(config);
    },
  });
}

/**
 * {@link /api/telegram/support-contacts/subjects}
 */
export function useTelegramSupportContactsGetSubjects<
  TData = TelegramSupportContactsControllerGetSubjectsQueryResponse,
  TQueryData = TelegramSupportContactsControllerGetSubjectsQueryResponse,
  TQueryKey extends QueryKey = TelegramSupportContactsGetSubjectsQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        TelegramSupportContactsControllerGetSubjectsQueryResponse,
        ResponseErrorConfig<TelegramSupportContactsControllerGetSubjects401>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? telegramSupportContactsGetSubjectsQueryKey();

  const query = useQuery(
    {
      ...telegramSupportContactsGetSubjectsQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<TelegramSupportContactsControllerGetSubjects401>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
